// i18n namespace "contact" (runtime top-level key: `quoteForm`; spec c.7 §9, COO decision 6).
// The admin CRM reads `quoteForm.option{Ai,Sap,Finance,Logistics}` as service labels:
// keep those four keys. The form chips use the shorter topic* labels. No SLA promise. Spanish uses tú.

export const en = {
  label: "Contact",
  title: "Talk to an SAP expert",
  lead: "Tell us what you run and what needs to change. A senior consultant replies personally.",
  direct: "Or write directly",
  emailLabel: "Email",
  phoneLabel: "Phone",
  name: "Name",
  email: "Work email",
  company: "Company",
  topic: "Topic",
  message: "What are you working on?",
  messagePlaceholder: "Your SAP release, the area involved and what needs to change.",
  optional: "(optional)",
  optionFinance: "SAP finance & e-invoicing",
  optionLogistics: "SAP logistics & warehouse",
  optionAi: "AI assistants on SAP",
  optionSap: "Other SAP work",
  topicFinance: "Finance & CFDI",
  topicLogistics: "Logistics & EWM",
  topicAi: "AI assistants",
  topicSap: "Other SAP work",
  submit: "Send message",
  sending: "Sending…",
  privacy: "We use your details only to reply.",
  privacyLink: "Privacy notice",
  errorPrefix: "Error:",
  summary: "Please check the following:",
  errName: "Enter your name.",
  errEmail: "Enter an email like name@company.com.",
  successTitle: "Thanks, {{name}}.",
  successBody: "We read every message personally. {{contactName}} will reply by email to {{email}}.",
  networkError: "We couldn’t send your message. Please email us instead:",
  honeypot: "Leave this field empty",
};

export const es = {
  label: "Contacto",
  title: "Habla con un experto SAP",
  lead: "Cuéntanos qué sistema usas y qué necesitas cambiar. Te responde personalmente un consultor senior.",
  direct: "O escríbenos directamente",
  emailLabel: "Correo",
  phoneLabel: "Teléfono",
  name: "Nombre",
  email: "Correo de trabajo",
  company: "Empresa",
  topic: "Tema",
  message: "¿En qué estás trabajando?",
  messagePlaceholder: "Tu versión de SAP, el área involucrada y qué necesitas cambiar.",
  optional: "(opcional)",
  optionFinance: "Finanzas SAP y facturación electrónica",
  optionLogistics: "Logística y almacén en SAP",
  optionAi: "Asistentes de IA sobre SAP",
  optionSap: "Otro tema de SAP",
  topicFinance: "Finanzas y CFDI",
  topicLogistics: "Logística y EWM",
  topicAi: "Asistentes de IA",
  topicSap: "Otro tema de SAP",
  submit: "Enviar mensaje",
  sending: "Enviando…",
  privacy: "Usamos tus datos solo para responderte.",
  privacyLink: "Aviso de privacidad",
  errorPrefix: "Error:",
  summary: "Revisa lo siguiente:",
  errName: "Escribe tu nombre.",
  errEmail: "Escribe un correo como nombre@empresa.com.",
  successTitle: "Gracias, {{name}}.",
  successBody: "Leemos cada mensaje personalmente. {{contactName}} te responderá por correo a {{email}}.",
  networkError: "No pudimos enviar tu mensaje. Escríbenos directamente:",
  honeypot: "Deja este campo vacío",
};

export const fr = {
  label: "Contact",
  title: "Parler à un expert SAP",
  lead: "Dites-nous ce que vous utilisez et ce qui doit changer. Un consultant senior vous répond personnellement.",
  direct: "Ou écrivez-nous directement",
  emailLabel: "E-mail",
  phoneLabel: "Téléphone",
  name: "Nom",
  email: "E-mail professionnel",
  company: "Entreprise",
  topic: "Sujet",
  message: "Sur quoi travaillez-vous ?",
  messagePlaceholder: "Votre version de SAP, le domaine concerné et ce qui doit changer.",
  optional: "(facultatif)",
  optionFinance: "Finance SAP et facturation électronique",
  optionLogistics: "Logistique et entrepôt SAP",
  optionAi: "Assistants IA sur SAP",
  optionSap: "Autre sujet SAP",
  topicFinance: "Finance et CFDI",
  topicLogistics: "Logistique et EWM",
  topicAi: "Assistants IA",
  topicSap: "Autre sujet SAP",
  submit: "Envoyer le message",
  sending: "Envoi…",
  privacy: "Nous utilisons vos données uniquement pour vous répondre.",
  privacyLink: "Politique de confidentialité",
  errorPrefix: "Erreur :",
  summary: "Veuillez vérifier les points suivants :",
  errName: "Saisissez votre nom.",
  errEmail: "Saisissez un e-mail comme nom@entreprise.com.",
  successTitle: "Merci, {{name}}.",
  successBody: "Nous lisons chaque message personnellement. {{contactName}} vous répondra par e-mail à {{email}}.",
  networkError: "Nous n’avons pas pu envoyer votre message. Écrivez-nous directement :",
  honeypot: "Laissez ce champ vide",
};

export const pt = {
  label: "Contato",
  title: "Fale com um especialista SAP",
  lead: "Conte o que você usa e o que precisa mudar. Um consultor sênior responde pessoalmente.",
  direct: "Ou escreva diretamente",
  emailLabel: "E-mail",
  phoneLabel: "Telefone",
  name: "Nome",
  email: "E-mail corporativo",
  company: "Empresa",
  topic: "Assunto",
  message: "No que você está trabalhando?",
  messagePlaceholder: "Sua versão do SAP, a área envolvida e o que precisa mudar.",
  optional: "(opcional)",
  optionFinance: "Finanças SAP e faturamento eletrônico",
  optionLogistics: "Logística e armazém no SAP",
  optionAi: "Assistentes de IA no SAP",
  optionSap: "Outro assunto de SAP",
  topicFinance: "Finanças e CFDI",
  topicLogistics: "Logística e EWM",
  topicAi: "Assistentes de IA",
  topicSap: "Outro assunto de SAP",
  submit: "Enviar mensagem",
  sending: "Enviando…",
  privacy: "Usamos seus dados apenas para responder.",
  privacyLink: "Aviso de privacidade",
  errorPrefix: "Erro:",
  summary: "Verifique o seguinte:",
  errName: "Digite seu nome.",
  errEmail: "Digite um e-mail como nome@empresa.com.",
  successTitle: "Obrigado, {{name}}.",
  successBody: "Lemos cada mensagem pessoalmente. {{contactName}} vai responder por e-mail para {{email}}.",
  networkError: "Não conseguimos enviar sua mensagem. Escreva diretamente:",
  honeypot: "Deixe este campo vazio",
};
